<!--
  功能：广告报表
-->
<template>
<div class="qcAdReport">
  <div class="page-title">{{title}}</div>
  <!-- 表单查询 -->
  <el-form ref="queryFormRef" class="query-form" label-width="80px" :model="queryForm">
    <div>
      <el-form-item label="日期范围">
        <el-date-picker @change="changeTime"
          v-model="timeDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="日期维度">
        <el-select v-model="queryForm.dateType" @change="changeTime" placeholder="请选择">
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </div>
    <!-- <div>
      <el-form-item label="数据维度">
        <el-radio-group v-model="queryForm.dataType" @change="changeDataType">
          <el-radio-button v-for="item in dataSum" :key="item.value" :label="item.value">{{item.type}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </div> -->
    <div>
      <el-form-item label="产品">
        <el-select v-show="queryForm.dataType == 1||queryForm.dataType == 2 || queryForm.dataType == 3 "
        v-model="queryForm.productId" @change="changeTime" clearable placeholder="请选择产品">
          <el-option
            v-for="item in productData"
            :key="item.productId"
            :label="item.productName"
            :value="item.productId">
          </el-option>
        </el-select>
        <el-select v-show=" queryForm.dataType == 2 || queryForm.dataType == 3 "
        v-model="queryForm.projectId" @change="changeTime" clearable placeholder="请选择项目">
          <el-option
            v-for="item in projectData"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <el-select v-show=" queryForm.dataType == 3 || queryForm.dataType == 4 || queryForm.dataType == 5 "
        v-model="queryForm.accountId" @change="changeTime" filterable clearable placeholder="请选择投放账户">
          <el-option
            v-for="item in accountData"
            :key="item.agentAccountId"
            :label="item.agentAccountName"
            :value="item.agentAccountId">
          </el-option>
        </el-select>
        <el-input :placeholder="'请输入'+(queryForm.dataType == 4?'广告组':'计划')+'名称'" v-model="queryForm.searchName" v-show=" queryForm.dataType == 4 || queryForm.dataType == 5 " class="input-with-search">
          <el-button @click="changeTime" slot="append" icon="iconfont icon-sousuo"></el-button>
        </el-input>
        <el-button @click="resetForm" type="info" size="medium">重置选项</el-button>
      </el-form-item>
      <el-form-item class="fr">
        <el-button v-permission="'adReport:applyCustomColunData'"
        @click="showColDialog" icon="iconfont icon-zidingyiguanli-copy" style="margin-right: 13px;" type="primary" size="medium">
          自定义列
        </el-button>
        <el-button v-permission="'adReport:downloadAdReport'" :disabled="allData.pageData.length == 0"
        @click="downloadAdReport" type="primary" icon="iconfont icon-xiazai-copy" size="medium">下载报表</el-button>
      </el-form-item>
    </div>
  </el-form>
  <!-- 表格 -->
  <el-table
    @sort-change="changeSort"
    :key="itemkey"
    :data="allData.pageData"
    v-loading="tableLoading"
    :max-height="tabheight"
    ref="table"
    class="roleTable"
    border
    style="width: 100%">
    <el-table-column label="时间" min-width="148px" prop="reportDate" fixed></el-table-column>
    <el-table-column
      v-for="(col,index) in allData.headerData"
      :key="index"
      :fixed="col.fixed"
      :prop="col.dictValue"
      :label="col.dictName"
      :sortable="col.orderField?'custom':false"
      :min-width="getTableColumnWidth(col.dictName)">
    </el-table-column>
  </el-table>
  <!-- 分页 -->
  <div class="paging-box" v-if="pageTotal > 0">
    <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page.sync="queryForm.pageNum"
      :page-sizes="[10, 20, 40, 80, 100]"
      @size-change="handleSizeChange"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="pageTotal">
    </el-pagination>
  </div>
  <!-- 自定义列对话框 -->
  <set-cols :colsDialogFlag.sync="colsDialogFlag" @dragEnd="dragEnd" :leftMenu="true"
  :listdata="listdata" :checkedList="checkedList" :editBtn="editBtn" :chooseMinNum='4'></set-cols>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import setCols from './../../../components/setCols'
// 公用
import { handleTimeOld, handleTimeNew, getChars } from '@/components/public'

export default {
  // 组件名称
  name: 'adReport',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    draggable,
    setCols
  },
  // 组件状态值
  data() {
    return {
      title: '广告账户',
      tabheight: null,
      tableLoading: true,
      itemkey: '', // 临时变量
      userId: '', // 用户id
      timeDate: [handleTimeOld(new Date()), handleTimeNew(new Date())],
      // 查询表单
      queryForm: {
        timeStar: handleTimeOld(new Date()),
        timeEnd: handleTimeNew(new Date()),
        dateType: 1, // 日期维度
        dataType: 3, // 数据维度
        productId: '',
        projectId: '',
        accountId: '',
        searchName: '',
        orderName: '', // 排序字段
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      sortNum: 'costasc', // 排序选中图标
      // 分页
      pageTotal: 0,
      // 选择日期维度
      timeOptions: [{
        value: 1,
        label: '分日'
      // }, {
      //   value: 2,
      //   label: '分时'
      }],
      // 数据维度
      dataSum: [{
        value: 1,
        type: '产品'
      }, {
        value: 2,
        type: '项目'
      }, {
        value: 3,
        type: '投放账户'
      }, {
        value: 4,
        type: '广告组'
      }, {
        value: 5,
        type: '计划'
      }],
      // 选择产品
      productData: [],
      // 选择项目
      projectData: [],
      // 选择投放账户
      accountData: [],
      // 表格数据
      allData: {
        headerData: [],
        pageData: []
      },
      // 自定义列对话框
      colsDialogFlag: false,
      editBtn: true, // 自定义列应用按钮显示隐藏
      // 勾选上的列表
      checkedList: [],
      listdata: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['screeningProduct', 'screeningProject'])
  },
  // 侦听器
  watch: {
    // 监测路由变化
    $route (to) {
      this.initType(to.path)
      this.changeDataType()
    }
  },
  // 组件在内存中被创建
  created() {
    // this.adReportListData() // 获取查询数据
    this.ppaDataList() // 筛选数据--产品、项目、账户
    this.initType(this.$route.path)
  },
  // 组件被渲染到页面
  mounted() {},
  // 组件方法
  methods: {
    initType(path) {
      if (path === '/qianchuan/report/base/qcaccount') {
        this.queryForm.dataType = 3
        this.title = '广告账户'
      } else if (path === '/qianchuan/report/base/qcgroup') {
        this.queryForm.dataType = 4
        this.title = '广告组'
      } else if (path === '/qianchuan/report/base/qcplan') {
        this.queryForm.dataType = 5
        this.title = '广告计划'
      }
    },
    getTableColumnWidth(str) {
      if (str === '广告计划') {
        return '320px'
      }
      let num = getChars(str)
      if (num >= 18) {
        return (num) + ('0px')
      } else {
        return '160px'
      }
    },
    // 筛选数据--产品、项目、账户
    ppaDataList () {
      this.$service.post('/api/qc/adReport/ppaDataList', {platformType: parseInt(localStorage.platformType)}).then(res => {
        if (res.code === 200) {
          for (var key in res.result) {
            if (key === 'productData') {
              this.productData = res.result.productData
            } else if (key === 'projectData') {
              this.projectData = res.result.projectData
            } else {
              this.accountData = res.result.accountData
            }
          }
          this.changeTime()
        } else {
          this.adReportListData()
        }
      }).catch(Err => {})
    },
    // 列表
    adReportListData () {
      this.tableLoading = true
      console.log(this.queryForm)
      this.$service.post('/api/qc/adReport/adReportListData', this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableLoading = false
          // this.itemkey = Math.random() // 在这边给key赋随机值，刷新表格
          this.allData.headerData = res.result.headerData
          this.allData.pageData = res.result.pageData
          this.pageTotal = res.result.total
          this.userId = res.result.userId
          this.allData.pageData.forEach((item, index) => {
            if (index !== 0 && this.queryForm.dateType === 2) {
              let hours = item.reportDate.split(' ')[1]
              hours = hours < 10 ? '0' + hours : hours
              item.reportDate = item.reportDate.split(' ')[0] + ` ${hours}:00-${hours}:59`
            }
          })
          if (this.pageTotal > 5) {
            this.updatetabheight()
          } else {
            this.tabheight = null
          }
        }
      }).catch(Err => {
        this.tableLoading = false
      })
    },
    // 选择时间获取表格数据
    changeTime () {
      this.queryForm.pageNum = 1
      if (this.timeDate) {
        this.queryForm.timeStar = this.timeDate[0]
        this.queryForm.timeEnd = this.timeDate[1]
      } else {
        this.queryForm.timeStar = ''
        this.queryForm.timeEnd = ''
      }
      this.adReportListData()
    },
    // 切换数据维度，筛选置空，获取表格数据
    changeDataType (val) {
      this.queryForm.productId = ''
      this.queryForm.projectId = ''
      this.queryForm.accountId = ''
      // if (val === 1) {
      //   // 产品维度
      //   this.queryForm.productId = isNaN(this.screeningProduct) ? '' : this.screeningProduct
      // } else if (val === 2) {
      //   // 项目维度
      //   this.queryForm.productId = isNaN(this.screeningProduct) ? '' : this.screeningProduct
      //   this.queryForm.projectId = isNaN(this.screeningProject) ? '' : this.screeningProject
      // }
      this.queryForm.searchName = ''
      this.queryForm.orderName = '' // 排序字段
      this.itemkey = Math.random() // 在这边给key赋随机值，刷新表格
      this.changeTime()
    },
    // 排序 每次排序会触发
    changeSort(val) {
      console.log('changeSort', val.order)
      // column: {…} order: "ascending" prop: "date"
      // 根据当前排序重新获取后台数据,一般后台会需要一个排序的参数 , 然后请求数据, 重新渲染页面即可.
      if (val.order !== null) {
        if (val.order === 'ascending') {
          this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' asc'
        } else {
          this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' desc'
        }
      } else {
        this.queryForm.orderName = ''
      }
      this.adReportListData()
    },
    // 重置
    resetForm () {
      this.queryForm = {
        timeStar: handleTimeOld(new Date()),
        timeEnd: handleTimeNew(new Date()),
        dateType: 1, // 日期维度
        dataType: 3, // 数据维度
        productId: '',
        projectId: '',
        accountId: '',
        searchName: '',
        orderName: '', // 排序字段
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      }
      this.itemkey = Math.random() // 在这边给key赋随机值，刷新表格
      this.productData = []
      this.projectData = []
      this.accountData = []
      this.timeDate = [handleTimeOld(new Date()), handleTimeNew(new Date())]
      this.ppaDataList()
    },
    // 切换分页
    handleCurrentChange (val) {
      this.queryForm.pageNum = val
      this.adReportListData()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.adReportListData()
    },
    /*
    * 自定义列
    */
    // 显示自定义列对话框
    showColDialog () {
      this.checkedList = [] // 清空选中的列
      this.$service.post('/api/qc/adReport/adReportCustomColumnList', {
        'dataType': this.queryForm.dataType
      }).then(res => {
        if (res.code === 200) {
          this.listdata = res.result.columnData
          this.checkedList = res.result.columnOrderData
          this.colsDialogFlag = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 点击确定，获取拖动排序的列表
    dragEnd () {
      let jsonData = {
        'columnDetailData': this.checkedList,
        'dataType': this.queryForm.dataType
      }
      console.log(jsonData)
      this.$service.post('/api/qc/adReport/applyCustomColumnData', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.changeTime()
        }
      })
      // 隐藏对话框
      this.colsDialogFlag = false
    },
    /*
    * 下载报表
    */
    downloadAdReport () {
      this.queryForm.timeStar = this.timeDate[0]
      this.queryForm.timeEnd = this.timeDate[1]
      // 创建a标签下载
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.$instance.defaults.baseURL + '/api/qc/adReport/downloadAdReport?accountId=' +
      this.queryForm.accountId + '&dataType=' + this.queryForm.dataType +
      '&dateType=' + this.queryForm.dateType + '&productId=' + this.queryForm.productId +
      '&projectId=' + this.queryForm.projectId + '&searchName=' + this.queryForm.searchName +
      '&timeEnd=' + this.queryForm.timeEnd + '&timeStar=' + this.queryForm.timeStar + '&userId=' + this.userId +
      '&orderName=' + this.queryForm.orderName + '&pageNum=' + this.queryForm.pageNum + '&pageSize=' + this.queryForm.pageSize
      // console.log(link.href)
      link.setAttribute('download', '')
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    // 列表样式
    updatetabheight() {
      let height = document.documentElement.clientHeight
      let offsetTop = this.$refs.table.$el.offsetTop
      console.log('offsetTop', offsetTop)
      this.$nextTick(() => {
        this.tabheight = parseInt(height - offsetTop - 83)
      })
    }
  }
}
</script>

<style lang="less">
.qcAdReport {
  .query-form{
    margin-bottom: -11px;
  }
  // 统一修改表单高度为35px
  .el-form{
    .el-form-item {
      margin-bottom: 15px;
    }
  }
  .el-select,.el-input{
    height: 35px;
    font-size: 13px;
  }
  .el-form-item__error {
    padding-top: 1px;
  }
  .el-input__prefix, .el-input__suffix {
    height: auto;
  }
  .el-input__inner {
    height: 35px;
  }
  .input-with-search{
    margin-top: 3.5px;
    .el-input-group__append button.el-button{
      height: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/qianchuan/report/adReport.vue